import disneyBanner1 from "../src/images/Disney-Magic.png";
import disneyBanner2 from "../src/images/Disney-EPCOT.png";
import disneyBanner3 from "../src/images/Disney-Hollywood.png";
import disneyBanner4 from "../src/images/Disney-Animal.png";
import disneyBanner5 from "../src/images/Disney Thypoon Lagoon.png";
import disneyBanner6 from "../src/images/Disney-Blizzard.png";

import universalBanner1 from "../src/images/universal-Studios.png";
import universalBanner2 from "../src/images/universal-Islands.png";
import universalBanner3 from "../src/images/universal-Volcano.png";

/**Imagenes para atracciones principales */
import bigThunder from "./images/atractions/Big-Thunder.png";
import dumbo from "./images/atractions/Dumbo.png";
import haunted from "./images/atractions/Haunted-Mansion.png";
import guardians from "./images/atractions/Guardians.png";
import mission from "./images/atractions/Mission-Space.png";
import space from "./images/atractions/Restaurante-Space.png";
import galaxy from "./images/atractions/Galaxy-Edge.png";
import runaway from "./images/atractions/Runaway-Railway.png";
import land from "./images/atractions/Toy-Story-Land.png";
import tree from "./images/atractions/Tree-of-Life.png";
import nemo from "./images/atractions/Finding-Nemo.png";
import station from "./images/atractions/Conservation-Station.png";
import typhoon from "./images/atractions/Typhoon-Lagoon.png";
import crush from "./images/atractions/Crush.png";
import adventure from "./images/atractions/Miss-Adventure.png";
import plummet from "./images/atractions/Summit-Plummet.png";
import runOff from "./images/atractions/Runoff-Rapids.png";
import toboggan from "./images/atractions/Toboggan-Racers.png";
import wizarding from "./images/atractions/Wizarding-World.png";
import minions from "./images/atractions/Minion.png";
import gringotts from "./images/atractions/Gringotts.png";
import jurassic from "./images/atractions/Jurassic-Park.png";
import hogsmade from "./images/atractions/Hogsmeade.png";
import hagrid from "./images/atractions/Hagrid-Magical.png";
import ohno from "./images/atractions/Ohno-of-Ohyah.png";
import krakatua from "./images/atractions/Krakatau-Aqua.png";
import kopika from "./images/atractions/Kopika-Wai.png";

export const tabsDataDisney = {
  magic_kingdom: {
    image: disneyBanner1,
    title: "Magic Kingdom",
    description:
      "Explora todos los juegos y atracciones dentro del parque temático y deléitate con el entretenimiento y los encuentros divertidos con algunos amigos favoritos de Disney.",
    attractions: [
      {
        name: "Big Thunder Mountain Railroad",
        image: bigThunder,
        description:
          "¡Atraviesa una mina de oro en el paseo más salvaje de la naturaleza!",
      },
      {
        name: "Dumbo the Flying",
        image: dumbo,
        description:
          "Agarra tu pluma mágica y prepárate para surcar los cielos en Storybook Circus.",
      },
      {
        name: "Haunted Mansion",
        image: haunted,
        description:
          "Deslízate por una espeluznante finca habitada por espíritus y fantasmas.",
      },
    ],
    isWatterPark: false,
  },
  epcot: {
    image: disneyBanner2,
    title: "EPCOT",
    description:
      "Disfruta de atracciones emocionantes, festivales temáticos, cocina goumert internacional, entretenimiento en vivo y mucho más en Epcot.",
    attractions: [
      {
        name: "Guardians of the Galaxy: Cosmic Rewind",
        image: guardians,
        description:
          "Despega en una montaña rusa de última generación inspirada en las mejores películas de Guardians of the Galaxy.",
      },
      {
        name: "Restaurante Space 220",
        image: space,
        description:
          "Disfruta de una experiencia culinaria de otro mundo con vistas celestiales a 220 millas de distancia de la tierra.",
      },
      {
        name: "Mission: SPACE",
        image: mission,
        description:
          "Agárrate fuerte en un viaje en cohete a Marte a bordo de un simulador de transbordador de la NASA.",
      },
    ],
    isWatterPark: false,
  },
  hollywood_studios: {
    image: disneyBanner3,
    title: "Disney's Hollywood Studios",
    description:
      "Adéntrate en un mundo completamente inspirado por las películas clásicas de Disney y mira como los populares personajes de Disney y Pixar dan vida a la magia de los cuentos.",
    attractions: [
      {
        name: "Star Wars: Galaxy Edge",
        image: galaxy,
        description:
          "Vive tu propia aventura de Star Wars en una galaxia muy, muy lejana.",
      },
      {
        name: "Toy Story Land",
        image: land,
        description:
          "Visita el patio de Andy y prepárate para jugar con algunos de tus amigos favoritos de Toy Story.",
      },
      {
        name: "Mickey & Minnie´s Runaway Railway ",
        image: runaway,
        description:
          "Entra al mundo de las caricaturas por primera vez para ir de picnic con Mickey, Minnie y sus amigos.",
      },
    ],
    isWatterPark: false,
  },
  animal_kingdom: {
    image: disneyBanner4,
    title: "Disney's Animal Kingdom",
    description:
      "Explora todos los juegos y atracciones ofrecidos con la magia de la naturaleza y entretenimiento salvaje.",
    attractions: [
      {
        name: "Tree of Life",
        image: tree,
        description:
          "Comienza el día examinando este ícono del parque, que tiene tallados más de 300 animales.",
      },
      {
        name: "Finding Nemo: The Big Blue… and Beyond!",
        image: nemo,
        description:
          "Sumérgete en el océano y rememora la historia de Finding Nemo, que cobra vida a través de increíbles marionetas.",
      },
      {
        name: "Conservation Station",
        image: station,
        description:
          "Da un paseo por la parte salvaje hasta Conservation Station, donde podrás conocer a Timón y Rafiki de The Lion King.",
      },
    ],
    isWatterPark: false,
  },
  typhoon_lagoon: {
    image: disneyBanner5,
    title: "Disney's Typhoon Lagoon",
    description:
      "Junta a tu tripulación y suban a bordo para vivir un emocionante viaje en aguas bravas en la amplia variedad de atracciones acuáticas.",
    attractions: [
      {
        name: "Typhoon Lagoon Surf Pool",
        image: typhoon,
        description:
          "El surf se practica todo el día con un flujo continuo de olas en la piscina de olas más grande de América del Norte.",
      },
      {
        name: "Crush ‘n’ Gusher",
        image: crush,
        description:
          "Toma a un amigo y sumérgete en un paseo en balsa similar a una montaña rusa para 2 personas con emocionantes chapuzones y giros.",
      },
      {
        name: "Miss Adventure Falls",
        image: adventure,
        description:
          "Reúne a tu tripulación para una emocionante aventura de rafting que es divertida para toda tu familia.",
      },
    ],
    isWatterPark: true,
  },
  blizzard_beach: {
    image: disneyBanner6,
    title: "Disney's Blizzard Beach",
    description:
      "Descubre un sinfín de diversión en el Parque Acuático Disney's Blizzard Beach, con toboganes de agua, atracciones con balsas, un río apacible y una piscina increíble.",
    attractions: [
      {
        name: "Summit Plummet",
        image: plummet,
        description:
          "Desciende por Mount Gushmore en uno de los toboganes de caída libre más altos y rápidos del mundo.",
      },
      {
        name: "Runoff Rapids",
        image: runOff,
        description:
          "Descubre 3 veces más emociones mientras te arrojas por estos tres diferentes toboganes acuáticos con botes inflables.",
      },
      {
        name: "Toboggan Racers",
        image: toboggan,
        description:
          "Compite hasta la línea de llegada en este emocionante tobogán acuático de 8 carriles.",
      },
    ],
    isWatterPark: true,
  },
};

export const tabsDataUniversal = {
  universal_studios: {
    image: universalBanner1,
    title: "Universal Studios",
    description:
      "En Universal Studios Florida tú eres la estrella, así que prepárate para disfrutar de una aventura sorprendente tras otra.",
    attractions: [
      {
        name: "The Wizarding World of Harry Potter: Diagon Alley",
        image: wizarding,
        description:
          "Sigue los pasos de Harry Potter y camina por las calles de Londres hasta llegar a Diagon Alley™, donde encontrarás muchos de los establecimientos más famosos del mundo mágico.",
      },
      {
        name: "Despicable Me Minion Mayhem",
        image: minions,
        description:
          "Únete a Gru, sus hijas y los traviesos Minios en un viaje inolvidable por el laboratorio del supervillano de Gru. Diversión sana y cómica para toda la familia.",
      },
      {
        name: "Harry Potter and the Escape from Gringotts",
        image: gringotts,
        description:
          "Mientras recorres las peligrosas bóvedas subterráneas, te encontrarás con Harry, Ron y Hermione.",
      },
    ],
    isWatterPark: false,
  },
  islands: {
    image: universalBanner2,
    title: "Islands of Adventure",
    description:
      "Entra a tierras míticas en Universal Islands of Adventure, donde se vuelven reales los superhéroes, las bestias y las criaturas mágicas.",
    attractions: [
      {
        name: "Jurassic Park River Adventure",
        image: jurassic,
        description:
          "En un momento estás navegando tranquilamente sobre agua. En el siguiente, te encuentras frente a frente con un enorme T-Rex. Tu único escape es una caída al vacío, desde 85 pies (25.9 metros) de altura.",
      },
      {
        name: "The Wizarding World of Harry Potter – Hogsmeade",
        image: hogsmade,
        description:
          "Situada en la base del castillo de Hogwarts™, encontrarás una mágica aldea llena de nieve, con tiendas encantadas, una apetecible taberna y mucho más.",
      },
      {
        name: "Hagrid’s Magical Motorbike Adventure",
        image: hagrid,
        description:
          "Vuela con Hagrid™ a lo profundo del Bosque Prohibido, más allá de los terrenos del castillo de Hogwarts™, en una montaña rusa que acelera por donde viven algunas de las criaturas mágicas más extrañas del mundo mágico.",
      },
    ],
    isWatterPark: false,
  },
  volcano_bay: {
    image: universalBanner3,
    title: "Volcano Bay",
    description:
      "Disfruta de la emoción y la relajación en el mejor parque acuático de Orlando, Universal's Volcano Bay.",
    attractions: [
      {
        name: "Ohno of Ohyah & Ohno Drop Slides",
        image: ohno,
        description:
          "Cruza el abismo y escoge el tobogán Ohno Slide, una aventura llena de giros que termina seis pies sobre una piscina.",
      },
      {
        name: "Krakatua Aqua Coaster",
        image: krakatua,
        description:
          "Prepárate para enfrentarte al poder de Krakatua en esta emocionante atracción. Las canoas para cuatro personas se deslizan por la niebla, hacia las oscuras vueltas dentro del volcán, antes de salir salpicando agua.",
      },
      {
        name: "Kopika Wai Winding River",
        image: kopika,
        description:
          "Viaja tranquilamente por Kopiko Wai Winding River, a través del paisaje tropical de Universal’s Volcano Bay, un lugar lleno de sorpresas.",
      },
    ],
    isWatterPark: true,
  },
};

export const ticketsDisney = [
  {
    title: "Ticket Mágico de 4 días, 4 parques",
    subtitle: "",
    title_desc: "",
    description:
      "Incluye una entrada a cada uno de los 4 Walt Disney World Theme Parks (Magic Kingdom Park, EPCOT, Disney's Hollywood Studios y Disney's Animal Kingdom Theme Park), para un total de 4 entradas en 4 días distintos.",
  },
  {
    title: "Ticket para Parque Temático",
    subtitle: "Ticket estándar con fecha de 1 a 10 días",
    title_desc: "Opción Hopper:",
    description:
      "Visita más de un Parque Temático en el mismo día. La posibilidad de visitar un Parque está sujeta a las limitaciones de capacidad de ese Parque.",
  },
  {
    title: "Ticket para Parque Temático",
    subtitle: "Ticket estándar con fecha de 1 a 10 días",
    title_desc: "Opción Water Park and Sports:",
    description:
      "Visita un Parque Temático por día y, además disfruta de una cantidad determinada de visitas a un Parque Acuático o a otro establecimiento de entretenimiento de Walt Disney World. Un ticket de 2 días equivale a 2 visitas, un ticket de 3 días equivale a 3 visitas y un ticket de 4 días equivale a 4 visitas.",
  },
  {
    title: "Ticket para Parque Temático",
    subtitle: "Ticket estándar con fecha de 1 a 10 días",
    title_desc: "Opción Park Hopper Plus:",
    description:
      "Visita un Parque Temático en el mismo día y disfruta una cantidad determinada de visitas a un Parque Acuático o a otro centro de entretenimiento de Walt Disney World. Un ticket de 2 días equivale a 2 visitas, un ticket de 3 días equivale a 3 visitas y un ticket de 4 días equivale a 4 visitas. La posibilidad de visitar un Parque está sujeta a las limitaciones de capacidad de ese Parque.",
  },
];

export const ticketsUniversal = [
  {
    title: "Entrada promocional de 3 días + 2 días gratis",
    subtitle: "(3 Parques, un parque por día)",
    title_desc: "Visita un parque por día:",
    description: [
      "Estudios Universal de Florida",
      "Islas de aventura de Universal",
      "Bahía del Volcán Universal",
    ],
  },
  {
    title: "Billete de 3 días",
    subtitle: "(2 Parques, varios por día)",
    title_desc: "Mueve libremente entre:",
    description: [
      "Estudios Universal de Florida",
      "Islas de aventura de Universal",
    ],
  },
  {
    title: "Billete de 3 días",
    subtitle: "(3 Parques, varios por día)",
    title_desc: "Mueve libremente entre:",
    description: [
      "Estudios Universal de Florida",
      "Islas de aventura de Universal",
      "Bahía del Volcán Universal",
    ],
  },
];

export const settings = {
  dots: false,
  infinite: true,
  arrows: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2500,
  centerMode: true,
  variableWidth: true,
  slidesToShow: 1,
  spaceBetween: 15,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const settingsMethods = {
  dots: false,
  autoplay: true,
  autoplaySpeed: 2500,
  infinite: true,
  arrows: false,
  speed: 500,
  slidesToShow: 5,
  spaceBetween: 15,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const settingsCertificado = {
  dots: false,
  infinite: true,
  arrows: false,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
        infinite: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const settingsDestinos = {
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 2500,
  slidesToShow: 1,
  centerMode: true,
  variableWidth: true,
  dots: false,
  arrows: true,
};

export const settingsHoteles = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2500,
  arrows: false,
  speed: 500,
  slidesToShow: 4,
  spaceBetween: 15,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const settingsActividades = {
  dots: false,
  infinite: true,
  arrows: false,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2500,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const settingsInfoHotel = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2800,
  arrows: false,
  speed: 600,
  slidesToShow: 4,
  spaceBetween: 15,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const settingsTraslados1 = {
  dots: false,
  infinite: false,
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 2500,
  slidesToScroll: 1,
  vertical: true,
  arrows: false,
  initialSlide: 0,
  verticalSwiping: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const settingsTraslados2 = {
  dots: false,
  infinite: true,
  arrows: false,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2500,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        initialSlide: 0,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export const handleScroll = (idSection) => {
  const section = document.getElementById(idSection);
  section.scrollIntoView({ behavior: "smooth" });
};
